module.exports = __webpack_public_path__ + "static/incre-modal-btn.80feadae.png";